export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const FETCH_EVENT = 'FETCH_EVENTS';
export const FETCH_USER_EVENTS = 'FETCH_USER_EVENTS';